import { persistCampaignAttributionFromUrl } from '@workspace/analytics/campaign-attribution';
import { initializePrivacyFirstPostHog } from '@workspace/analytics/posthog/client';

persistCampaignAttributionFromUrl();

initializePrivacyFirstPostHog({
  app: 'auth-app',
  key: process.env.NEXT_PUBLIC_POSTHOG_KEY,
});
